module.exports = __webpack_public_path__ + "static/img/one.244de10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/radishImg/one.png
// module id = 4aRG
// module chunks = 1